import "./Login.css";
import api from '../api.js';
import { useState, useEffect } from "react";
import { Logo, Field, Input, Checkbox, Button, Alert } from '../ds';

export default function Login({ onLogin }) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogIn = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await api.post("/api/auth/login", { login, password, rememberMe });
      const meRes = await api.get("/api/auth/me");
      localStorage.setItem("login", login);
      localStorage.setItem("me", JSON.stringify(meRes.data));
      if (onLogin) onLogin(login);
    } catch (err) {
      if (err.response) setError(typeof err.response.data === "string" ? err.response.data : err.response.data.message || "Ошибка при входе");
      else setError("Ошибка сети или сервера");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { document.title = "Вход в личный кабинет — WAve"; }, []);

  return (
    <div className="login">
      <div className="login-glow" aria-hidden="true" />
      <MotionLines className="login-lines login-lines--1" />
      <MotionLines className="login-lines login-lines--2" />

      <main className="login-card">
        <Logo variant="horizontal" height={34} />
        <h1 className="ds-h1 login-title">Вход в личный кабинет</h1>

        <form onSubmit={handleLogIn} className="login-form" noValidate>
          {error && <Alert tone="danger">{error}</Alert>}

          <Field label="Логин">
            <Input
              size="lg"
              autoComplete="username"
              required
              autoFocus
              value={login}
              invalid={Boolean(error)}
              onChange={(e) => setLogin(e.target.value)}
            />
          </Field>

          <Field label="Пароль">
            <Input
              size="lg"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              invalid={Boolean(error)}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Field>

          <Checkbox
            label="Запомнить меня"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />

          <Button type="submit" variant="primary" size="lg" block loading={loading} disabled={!login || !password}>
            Войти
          </Button>
        </form>

        <p className="ds-caption login-help">Нет доступа? Напишите администратору вашей компании</p>
      </main>

      <footer className="login-foot ds-caption">© {new Date().getFullYear()} WAve · wave-messaging.com</footer>
    </div>
  );
}

// Линии движения из знака логотипа — декоративный фон
function MotionLines({ className }) {
  return (
    <svg className={className} viewBox="0 0 98 54" fill="none" aria-hidden="true">
      <g transform="translate(1 1)" stroke="currentColor" strokeWidth="5.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M37 11V8.5a6 6 0 0 1 6-6h42.5a6 6 0 0 1 6 6v34.25a6 6 0 0 1-6 6H2.75" />
        <path d="M21 24h15M11.5 35.75H36" />
        <path d="M48 17.25l13 8.2a4 4 0 0 0 4.3 0L80.5 17" />
      </g>
    </svg>
  );
}
